import { useTranslation } from "react-i18next";

export default function AppScreenshots() {
  const { t } = useTranslation();

  const screenshots = [
    {
      id: 1,
      src: "/images/screenshots/screenshot1.png",
      alt: t("screenshots.items.1.alt"),
      description: t("screenshots.items.1.description"),
    },
    {
      id: 2,
      src: "/images/screenshots/screenshot2.png",
      alt: t("screenshots.items.2.alt"),
      description: t("screenshots.items.2.description"),
    },
    {
      id: 3,
      src: "/images/screenshots/screenshot3.png",
      alt: t("screenshots.items.3.alt"),
      description: t("screenshots.items.3.description"),
    },
    {
      id: 4,
      src: "/images/screenshots/screenshot4.png",
      alt: t("screenshots.items.4.alt"),
      description: t("screenshots.items.4.description"),
    },
    {
      id: 5,
      src: "/images/screenshots/screenshot5.png",
      alt: t("screenshots.items.5.alt"),
      description: t("screenshots.items.5.description"),
    },
  ];

  return (
    <section className="py-20 bg-white dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-12">
          {t("screenshots.title")}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {screenshots.map((screenshot) => (
            <div
              key={screenshot.id}
              className="group bg-gray-50 dark:bg-gray-700 rounded-xl p-4 shadow-md transition-transform duration-300 hover:-translate-y-2"
            >
              <div className="relative aspect-[9/16] rounded-lg overflow-hidden shadow-lg">
                <img
                  src={screenshot.src}
                  alt={screenshot.alt}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = "/images/screenshots/placeholder.png";
                  }}
                />
              </div>
              <p className="mt-4 text-center text-gray-600 dark:text-gray-300 font-medium">
                {screenshot.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <h3 className="text-2xl font-semibold text-gray-800 dark:text-white mb-6">
            {t("screenshots.features")}
          </h3>
          <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            {t("screenshots.featuresDescription")}
          </p>
        </div>
      </div>
    </section>
  );
}
